document.addEventListener('DOMContentLoaded', function() {
  
  const hcButtons = document.querySelectorAll('.collapsible-trigger-btn');
  const hcPopup = document.querySelector('.hc-popup-outer');
  const hcClose = document.querySelector('.hc-close');

  if(hcPopup){
    hcButtons.forEach(function(hcButton) {
      hcButton.addEventListener('click', function() {
        const hcAccordionActive = this.getAttribute('data-button');
        const hcAccordions = document.querySelectorAll('.hc-accordion');
        
        document.querySelector('body').classList.add('hc-popup-opened');
        hcPopup.classList.add('show');
        hcAccordions.forEach(function(hcAccordion) {
          hcAccordion.classList.remove('hc-active');
        });
  
        document.querySelector('.hc-accordion[data-content="'+hcAccordionActive+'"]').classList.add('hc-active');
        
      });
    });
    
    hcClose.addEventListener('click', function() {
      document.querySelector('body').classList.remove('hc-popup-opened');
      hcPopup.classList.remove('show');
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.template-cart')) return;

  const hcNote = document.getElementById('hc-note');
  const note = document.getElementById('note');
  let originalNote = '';

  hcNote.value = '';
  note.value = '';

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const lineAttr = new Set();

      hcNote.value = '';
      note.value = '';
      
      cart.items.forEach(item => {
        const pnNote = item.properties?.['PN-Note']?.trim();
        const productTitle = item.title?.trim();
        if (pnNote) lineAttr.add(`${productTitle} - ${pnNote}`);
      });

      const currentNote = note.value.trim();
      if (currentNote) lineAttr.add(currentNote);

      originalNote = Array.from(lineAttr).join(', ');
      note.value = originalNote;
    });

  hcNote.addEventListener('input', () => {
    const hcValue = hcNote.value.trim();
    note.value = hcValue ? `${originalNote}, ${hcValue}` : originalNote;
  });
});

